import React from 'react';
import PropTypes from 'prop-types';
import Icon from './HeaderIcon/HeaderIcon';
import iconGroup from '../../../../assets/images/icons/icon-group.png';
import iconShared from '../../../../assets/images/icons/icon-shared.png';
import iconUnion from '../../../../assets/images/icons/icon-union.png';
import LISTVIEW_TYPES from '../listViewTypes';

const button = {
  fontSize: '11px',
  fontWeight: '700',
  display: 'inline-block',
  cursor: 'pointer',
  textTransform: 'uppercase',
  padding: '7px 15px',
  backgroundColor: '#476166',
  color: '#CED7D9',
  outline: 'none',
  border: 'none',
};

const header = {
  display: 'flex',
  justifyContent: 'space-between',
  backgroundColor: '#ffffff',
  padding: '10px 15px 10px 15px',
  height: '50px',
};

const icons = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  height: '26px',
  width: '100px',
};

const ProjectListHeader = (props) => {
  const { listViewType, changeListView, toggleBatchEdit } = props;

  return (
    <div style={header}>
      <button style={button} onClick={e => toggleBatchEdit(e)}>
        Batch edit
      </button>
      <div style={icons}>
        <Icon
          src={iconGroup}
          onClick={() => changeListView(LISTVIEW_TYPES.grid)}
          isSelected={LISTVIEW_TYPES.grid === listViewType}
        />
        <Icon
          src={iconUnion}
          onClick={() => changeListView(LISTVIEW_TYPES.list)}
          isSelected={LISTVIEW_TYPES.list === listViewType}
        />
        <Icon
          src={iconShared}
          onClick={() => changeListView(LISTVIEW_TYPES.compressedList)}
          isSelected={LISTVIEW_TYPES.compressedList === listViewType}
        />
      </div>
    </div>
  );
};

ProjectListHeader.propTypes = {
  listViewType: PropTypes.string.isRequired,
  changeListView: PropTypes.func.isRequired,
  toggleBatchEdit: PropTypes.func.isRequired,
};

export default ProjectListHeader;



// WEBPACK FOOTER //
// ./src/components/Project/ProjectList/ProjectListHeader/ProjectListHeader.js